import {
    Avatar,
    Button,
    Card,
    Col,
    Descriptions,
    Empty,
    List,
    Row,
    Tag,
    Typography,
} from "antd";
import { LogoutOutlined } from "@ant-design/icons";

const { Text } = Typography;

function appInitial(name) {
    if (!name) return "?";
    const trimmed = String(name).trim();
    return trimmed ? trimmed[0].toUpperCase() : "?";
}

function isActive(item) {
    if (!item?.expire_time) return false;
    const exp = new Date(item.expire_time);
    return !isNaN(exp.getTime()) && exp.getTime() > Date.now();
}

export default function Console({ user, sessions, onLogout }) {
    return <>
        <Card
            title="Profile"
            extra={
                <Button danger icon={<LogoutOutlined />} onClick={onLogout}>
                    Logout
                </Button>
            }
        >
            <Row gutter={[24, 16]} align="middle" wrap>
                <Col flex="120px" style={{ textAlign: "center" }}>
                    <Avatar src="/html/student.png" size={120}>
                        {appInitial(user?.firstname || user?.username)}
                    </Avatar>
                </Col>
                <Col flex="auto" style={{ minWidth: 0 }}>
                    <Descriptions column={1} size="small" colon={false}>
                        <Descriptions.Item label="Username">
                            <Text strong>{user?.username}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Name">
                            <Text strong>{user?.firstname} {user?.lastname}</Text>
                        </Descriptions.Item>
                        {(user?.firstnameTH || user?.lastnameTH) && (
                            <Descriptions.Item label="ชื่อ-นามสกุล">
                                <Text strong>{user?.firstnameTH} {user?.lastnameTH}</Text>
                            </Descriptions.Item>
                        )}
                        {user?.email && (
                            <Descriptions.Item label="Email">
                                <Text type="secondary">{user.email}</Text>
                            </Descriptions.Item>
                        )}
                    </Descriptions>
                </Col>
            </Row>
        </Card>

        <Card title="Sessions" extra={<Text type="secondary">last 90 days</Text>}>
            {(!sessions || sessions.length === 0) ? (
                <Empty description="No sessions yet" />
            ) : (
                <List
                    itemLayout="horizontal"
                    dataSource={sessions}
                    renderItem={(item) => {
                        const active = isActive(item);
                        return (
                            <List.Item
                                className="session-row"
                                actions={[
                                    <Tag color={active ? "green" : "default"} key="status">
                                        {active ? "Active" : "Expired"}
                                    </Tag>,
                                ]}
                            >
                                <List.Item.Meta
                                    avatar={
                                        <Avatar src={item?.app_icon} shape="square" size={44}>
                                            {appInitial(item?.app_name)}
                                        </Avatar>
                                    }
                                    title={
                                        <Text strong>{item?.app_name || "Unknown app"}</Text>
                                    }
                                    description={
                                        <div style={{ lineHeight: 1.6 }}>
                                            <Text type="secondary">
                                                Client: {item?.create_time}
                                                {item?.client_ip ? ` @ ${item.client_ip}` : ""}
                                            </Text>
                                            <br />
                                            <Text type="secondary" style={{ wordBreak: "break-all" }}>
                                                Service: {item?.service_url}
                                            </Text>
                                            <br />
                                            <Text type="secondary">
                                                {item?.service_ip
                                                    ? `Validated: ${item.expire_time} @ ${item.service_ip}`
                                                    : `Valid until: ${item?.expire_time}`}
                                            </Text>
                                        </div>
                                    }
                                />
                            </List.Item>
                        );
                    }}
                />
            )}
        </Card>
    </>;
}
